import React from "react";

const TitleWithDash = ({ title, color, dashColor }) => {
  return (
    <div className="flex justify-start items-start xl:gap-x-[24px]">
      <div
        className="hidden xl:block min-w-[64px] w-[64px] h-[2px] mt-[24px]"
        style={{ background: dashColor }}
      />
      {title}
    </div>
  );
};

export default TitleWithDash;
